import type { Article } from "@paparazzi/components/blog/Blog";
import api from "@virgodev/bazaar/functions/api";
import { defineStore } from "pinia";
import { ref } from "vue";

export const usePulseStore = defineStore("pulse", () => {
  const articles = ref<Article[]>([]);
  const ordering = ref<string>("newest");
  const loaded = ref(false);

  async function loadArticles(slug: string | null) {
    let params = {
      page_size: 30,
      category: slug,
      ordering: ordering.value,
    };
    let url = "blog/articles/";
    const entries = Object.entries(params).filter((e) => e[1]);
    if (entries.length > 0) {
      url += "?";
      url += entries.map((e) => `${e[0]}=${e[1]}`).join("&");
    }

    const response = await api({ url });
    if (response.ok) {
      const list = response.body;
      articles.value = list;
    } else {
      articles.value = [];
    }

    loaded.value = true;

    return response;
  }

  return { articles, ordering, loaded, loadArticles };
});
